/**
 * Created by Yangxunwu on 2018/6/7.
 */

import request from '@/utils/request'

/**
 * 注册
 * @param phone
 * @param password
 * @param smsCode
 */
export function register(phone, smsCode) {

    const data = {
        phone,
        smsCode,
    };

    return request({
        url: '/user/user/register',
        method: 'post',
        data
    })
}

/**
 * 完善注册信息
 * @param password
 * @param corpName
 * @param userName
 */
export function finishRegister(password, corpName, userName) {

    const data = {
        password,
        corpName,
        userName,
    };

    return request({
        url: '/user/user/finish-register',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/api/register.js